// Modules
import webStorage from 'modules/storage';

interface IInitDateConfig {
  appTimeFormat: 'HH:mm' | 'hh:mm a';
  shouldUse12Hours: boolean;
  hoursTimeFormat: number;
  configureTimeFormat(format: 12 | 24): void;
}

const HOURS_FORMAT_12 = 12;
const HOURS_FORMAT_24 = 24;

const initDateConfig = (): IInitDateConfig => {
  const _24_HOURS = 'HH:mm';
  const _12_HOURS = 'hh:mm a';

  const getShouldUse12Hours = () => !!webStorage.getData<boolean>('timeGoUse12Hours');

  const configureTimeFormat = (format: 12 | 24) => {
    webStorage.setData<boolean>(format === HOURS_FORMAT_12, 'timeGoUse12Hours');
  };

  const getTimeFormat = () => {
    return getShouldUse12Hours() ? _12_HOURS : _24_HOURS;
  };

  const getTimeFormatHours = () => {
    return getShouldUse12Hours() ? HOURS_FORMAT_12 : HOURS_FORMAT_24;
  };

  return {
    configureTimeFormat,
    appTimeFormat: getTimeFormat(),
    shouldUse12Hours: getShouldUse12Hours(),
    hoursTimeFormat: getTimeFormatHours(),
  };
};

export default initDateConfig();
